// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2fBrK","clinicsSelect":"TableHeading_clinicsSelect__2MVo-"};